import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loading, EmptyState } from "@/components/common";
import PeriodFilter, { usePeriod } from "@/components/PeriodFilter";
import { rupiah } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function TrialBalance() {
  const { period, start_date, end_date, setPeriod } = usePeriod("month");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const p = { period }; if (period === "custom") { p.start_date = start_date; p.end_date = end_date; }
    setLoading(true);
    api.get("/accounting/trial-balance", { params: p }).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [period, start_date, end_date]);

  return (
    <div>
      <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="tb-title">Neraca Saldo</h1>
          <p className="text-sm text-slate-500 mt-1">Trial Balance dari jurnal yang sudah diposting.</p>
        </div>
        <PeriodFilter period={period} start_date={start_date} end_date={end_date} onChange={setPeriod} />
      </div>
      {loading ? <Loading /> : !data ? <EmptyState title="Data tidak tersedia" /> : (
        <>
          <div className={`mb-4 rounded-lg px-4 py-2 text-sm font-semibold ${data.balanced ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`} data-testid="tb-balance-status">
            {data.balanced ? "✓ Seimbang — Total Debit = Total Kredit" : "⚠ Tidak seimbang!"} · Debit {rupiah(data.total_debit)} / Kredit {rupiah(data.total_credit)}
          </div>
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-x-auto">
            {data.rows.length === 0 ? <EmptyState title="Belum ada mutasi pada periode ini" /> : (
              <Table>
                <TableHeader><TableRow><TableHead>Kode</TableHead><TableHead>Akun</TableHead><TableHead className="text-right">Saldo Awal</TableHead><TableHead className="text-right">Mutasi Debit</TableHead><TableHead className="text-right">Mutasi Kredit</TableHead><TableHead className="text-right">Saldo Debit</TableHead><TableHead className="text-right">Saldo Kredit</TableHead></TableRow></TableHeader>
                <TableBody>
                  {data.rows.map((r) => (
                    <TableRow key={r.code} data-testid={`tb-row-${r.code}`}>
                      <TableCell className="font-mono text-xs">{r.code}</TableCell>
                      <TableCell className="text-sm">{r.name}</TableCell>
                      <TableCell className="text-right tabular-nums text-slate-500">{rupiah(r.beginning)}</TableCell>
                      <TableCell className="text-right tabular-nums">{r.debit_movement ? rupiah(r.debit_movement) : "-"}</TableCell>
                      <TableCell className="text-right tabular-nums">{r.credit_movement ? rupiah(r.credit_movement) : "-"}</TableCell>
                      <TableCell className="text-right tabular-nums font-medium">{r.ending_debit ? rupiah(r.ending_debit) : "-"}</TableCell>
                      <TableCell className="text-right tabular-nums font-medium">{r.ending_credit ? rupiah(r.ending_credit) : "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </div>
        </>
      )}
    </div>
  );
}
